module.exports = __webpack_public_path__ + "static/media/birthdaycakeBlack.7203e42e.svg";